import * as React from 'react'

import type { NavigationRoutesFn } from 'modules/core/lib/react-router'

const ProfileRootPage = React.lazy(() => import('modules/performance_v2/pages/ProfileRootPage'))

const employeesRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.profile.performance.path,
      element: <ProfileRootPage />,
    },
  ]
}

export default employeesRoutes
